import React from 'react';
import { IconMoon, IconSun } from '@douyinfe/semi-icons';
import { useSetTheme, useTheme } from '../context/Theme';

const NAV = [
  { key: 'console', label: '令牌查询' },
  { key: 'models', label: '模型广场' },
];

const HeaderBar = ({ page, onNavigate, systemName = '砂糖酒馆' }) => {
  const theme = useTheme();
  const setTheme = useSetTheme();

  const go = (key) => {
    onNavigate && onNavigate(key);
  };

  return (
    <div className="w-header">
      <div className="w-header-inner">
        <button type="button" className="w-brand" onClick={() => go('console')}>
          <div className="w-brand-mark">🍶</div>
          <div className="w-brand-text">{systemName}</div>
        </button>

        <nav className="w-nav">
          <div className="w-nav-group">
            {NAV.map((item) => (
              <button
                key={item.key}
                type="button"
                className={page === item.key ? 'active' : ''}
                onClick={() => go(item.key)}
              >
                {item.label}
              </button>
            ))}
          </div>
        </nav>

        <div className="w-actions">
          <button
            type="button"
            className="w-icon-btn"
            title="切换主题"
            onClick={() => setTheme(theme !== 'dark')}
          >
            {theme === 'dark' ? <IconSun size="large" /> : <IconMoon size="large" />}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeaderBar;
